import React from "react";
import { Box, Table, Alert } from "@mui/joy";
import { useTranslation } from 'react-i18next';
import { Icon } from "src/mtska-frontend-app-component/assets";

const WidgetExternalIdentifiers = (props) => {
    const { t } = useTranslation();
    const externalIdentifiers = props.item?.externalIdentifiers ?? [];

    return (
        <>
            <Box className={"form-element external-identifiers " + props.className} sx={{ overflow: 'hidden' }}>
                {
                    externalIdentifiers.length > 0 && (
                        <Table sx={{ border: '1px solid var(--neutral-300)' }}>
                            <thead>
                                <tr>
                                    <th>{t('renter_name')}</th>
                                    <th>{t('renter_identifiers')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {externalIdentifiers.map((identifier, index) => (
                                    <tr key={index}>
                                        <td>{identifier.owner}</td>
                                        <td>{identifier.names?.join(', ')}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )
                }
                {
                    externalIdentifiers.length === 0 && (
                        <Alert
                            startDecorator={<Icon icon="faCircleInfo" />}
                            color="info"
                            variant="outlined"
                            sx={{ mt: 2 }}
                        >
                            Non sono presenti identificatori noleggiatori
                        </Alert>
                    )
                }
            </Box>
        </>
    );
};

export default WidgetExternalIdentifiers;